<template>
    <div class="form-page">
        <el-row :gutter="20">
            <el-col :span="6" v-for="(item,index) in configExt3[type]" :key="index">
                <div class="con" @click="link(item)">
                    <i class="iconfont" v-html="item.ico"></i>
                    <p>{{item.name}}</p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {configExt3} from './config/list';

export default {
    
    components: {},
    data() {
        return{
            configExt3,
            type:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        link(obj){
            if(obj.url.indexOf("/otc/index.html")!=-1){
                this.gotoFrame({
                    title:obj.name,
                    url:obj.url,
                })
            }else{
                var arr = obj.url.split("#/");
                var url = '/' + arr[1];
                // 判断是否包含问号
                if(url.indexOf("?") != -1){
                    url = url + '&t='+Math.random();
                }else{
                    url = url + '?t='+Math.random();
                }
                this.goto({path: url});
            }
        }
    },
    created() {
        this.type = this.getQuery('type');
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .con{ padding: 30px 10px;  text-align: center; cursor: pointer; background-color: #f4f4f5; }
    .con i{ font-size: 56px; color: #409eff; }
    .con p{ margin-top: 15px; font-size: 16px;}
    .el-col-6{ margin: 20px 0; }
</style>
